module.exports = __webpack_public_path__ + "img/sweden.e9f8adb7.png";